import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Input from '../../elements/input';
import CustomAutoComplete from '../../elements/AutoComplete';
import { fetchBusinessList } from '../../services/business.service';

import './styles.scss';

const BusinessSelectDropdown = ({ selectedData = '', handleChange }) => {
  const [jobBusinessList, setJobBusinessList] = useState([]);
  const [jobBusiness, setJobBusiness] = useState({ });

  useEffect(() => {
    if (!jobBusiness?.uuid?.trim() && !!jobBusinessList?.length && !!selectedData?.trim()) {
      let foundBusiness = { uuid: selectedData };
      foundBusiness = jobBusinessList.find((value) => {
        return value.uuid === selectedData;
      });
      setJobBusiness(foundBusiness);
    }
  }, [selectedData, jobBusinessList]);

  useEffect( () => {
    if (!jobBusinessList?.length) {
      getBusinessList();
    }
  }, [jobBusinessList?.length]);

  const getBusinessList = async () => {
    await fetchBusinessList(`?page=${1}&limit=${10000}`)
      .then(async (response) => {
        if (response?.data?.data?.results) {
          setJobBusinessList(response?.data?.data?.results);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      })
  }

  const jobBusinessChange = (event, values) => {
    handleChange(values?.uuid || null)
    setJobBusiness(values);
  }

  return (
    <div key={`businessFilter-key-${jobBusiness?.uuid ? 'defaulted' : 'empty'}`} className='company-filter'>
      <CustomAutoComplete
        id="company"
        options={jobBusinessList || []}
        getOptionLabel={(option) => `${option?.name || ""}`}
        onChange={jobBusinessChange}
        value={jobBusiness}
        renderInput={(params) => (
          <Input
            {...params}
            type="text"
            variant="outlined"
            title={`Company`}
            placeholder="Select Company"
            InputLabelProps={{
              shrink: false,
            }}
            size="small"
          />
        )}
      />
    </div>
  );
};
export default BusinessSelectDropdown;
